import React from 'react';
import { Leaf, Ship, Building2, Waves } from 'lucide-react';

const features = [
  { icon: Building2, title: 'Built for Hotels', text: 'Silent, elegant, guest-ready. Replaces every plastic bottle in your rooms.' },
  { icon: Ship, title: 'Made for Yachts', text: 'Marine-grade generators that turn ocean humidity into onboard drinking water.' },
  { icon: Leaf, title: 'Green by Design', text: 'Zero groundwater impact. A truly sustainable water source for premium properties.' },
  { icon: Waves, title: '4-Step Filtration', text: 'Patented condensation, purification, mineral balance & ozonation — in one loop.' }
];

export default function About() {
  return (
    <section id="about" className="relative py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div>
            <div className="text-xs tracking-[0.3em] text-sky-600 font-semibold uppercase mb-4">About Upgrade Water</div>
            <h2 className="font-display text-4xl md:text-5xl font-semibold text-slate-900 leading-tight">
              A new source of water for the world’s <span className="water-text">finest properties</span>.
            </h2>
            <p className="mt-6 text-slate-600 text-lg leading-relaxed">
              Upgrade Water builds atmospheric water generators for the hospitality and marine industries.
              Using patented condensation and multi-stage purification, our systems turn ambient humidity into
              cool, mineral-balanced, ozonated drinking water — without groundwater, plastic bottles, or waste.
            </p>
            <p className="mt-4 text-slate-600 leading-relaxed">
              From a boutique villa in the Maldives to a 60-metre yacht in Monaco, our devices give operators
              a reliable, on-demand water source that guests can taste and see. This is water, upgraded.
            </p>
            <div className="mt-8 flex items-center gap-6">
              <div className="flex -space-x-3">
                {[1,2,3,4].map(n => (
                  <div key={n} className={`w-11 h-11 rounded-full border-2 border-white bg-gradient-to-br shadow-md ${['from-sky-400 to-cyan-500','from-cyan-400 to-teal-500','from-blue-400 to-sky-500','from-teal-400 to-emerald-500'][n-1]}`} />
                ))}
              </div>
              <div className="text-sm text-slate-600">Trusted by <span className="font-semibold text-slate-900">180+ premium properties</span> worldwide</div>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-5">
            {features.map((f, idx) => {
              const Icon = f.icon;
              return (
                <div key={f.title} className={`relative p-6 rounded-3xl border border-sky-100 bg-gradient-to-b from-white to-sky-50/60 hover:shadow-xl hover:shadow-sky-100 transition-all duration-500 ${idx % 2 === 1 ? 'sm:translate-y-8' : ''}`}>
                  <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-sky-500 to-cyan-600 flex items-center justify-center shadow-lg shadow-sky-200 mb-4">
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                  <div className="font-display text-xl font-semibold text-slate-900">{f.title}</div>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{f.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
